import React from "react";
import Svg, { Defs, G, Path, SvgProps } from "react-native-svg";

const TickIcon = (props: SvgProps) => {
  return (
    <Svg fill="none" width="33" height="33" viewBox="0 0 35 35" {...props}>
      <G clipPath="url(#a)">
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.5 32.01a16 16 0 1 1 0-32 16 16 0 0 1 0 32ZM7.44 19.618a1.858 1.858 0 0 1 0-2.613l.943-.937a1.696 1.696 0 0 1 2.44.027l1.663 1.727a.85.85 0 0 0 1.233 0l8.48-8.741a1.699 1.699 0 0 1 2.453-.015l.915.925a1.857 1.857 0 0 1 0 2.585l-11.258 11.44a1.7 1.7 0 0 1-2.428.016l-4.44-4.414Z"
          fill="#43A314"
        />
      </G>
      <Defs>
        <clipPath id="a">
          <Path fill="#fff" transform="translate(.5 .01)" d="M0 0h32v32H0z" />
        </clipPath>
      </Defs>
    </Svg>
  );
};

export default TickIcon;
